export class EstadoInventarioProducto {
  id: number;
  estado: string;
}